import React, { useState } from "react";
import * as XLSX from "xlsx";
import Table from "../../components/common/table/Table";
import { postApi } from "../../services/api/globalApi";
import { getNumberFromString } from "../../utils/getNumberFromString";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { notFoundCoursesUserListColumns } from "../../constant/tables-columns/tablesColums";
import { covertNumberToEn } from "../../utils/converNumberToEn";

function RegisterMultiple() {
  const [jsonData, setJsonData] = useState([]);
  const [notFoundData, setNotFoundData] = useState([]);
  const [courseName, setCourseName] = useState("");
  const [error, setError] = useState("");

  const handleFileUpload = (event) => {
    setError("");
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        const userData = [];
        for (let index = 0; index < json.length; index++) {
          const item = json[index];
          if (!item["mobile"] && !item["name"]) {
            continue;
          }
          if (!item["mobile"]) {
            throw new Error(
              ` در برخی از آیتم ها موبایل معتبر نیست ${item["mobile"]} => row ${
                item.__rowNum__ + 1
              }`
            );
          }
          if (!item["name"]) {
            throw new Error(
              ` در برخی از آیتم ها نام معتبر نیست ${item["mobile"]} => row ${
                item.__rowNum__ + 1
              } `
            );
          }
          userData.push({
            mobile: covertNumberToEn(item["mobile"]),
            name: item["name"],
          });
        }

        setNotFoundData([]);
        setJsonData(userData);
      } catch (err) {
        setError(err.message);
        setJsonData([]);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleUploadBarcode = async () => {
    const path = "admin/courseEnrollments/register/multiple";
    const body = {
      courseName,
      data: jsonData,
    };
    console.log(jsonData);

    if (!body.data?.length) {
      return warningMessage("اطلاعاتی وجود ندارد");
    }
    try {
      const response = await postApi({ path, body });
      successMessage("عملیات با موفقیت اجام شد.");
      setJsonData([]);
      if (response?.data?.result?.length) {
        setNotFoundData(response?.data?.result);
      }
    } catch (error) {
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 text-gray-800 dark:text-white rounded-3xl p-6">
      <h1 className="">ثبت نام در دوره</h1>
      <h4 className="mt-3 text-blue">** ستون name و ستون mobile الزامی است</h4>
      <div className="w-11/12 mx-auto mt-6">
        <label className="mt-4 block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          فایل اکسل
        </label>
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 cursor-pointer focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        />
        <label className="mt-4 block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          نام دوره
        </label>
        <input
          type="text"
          required
          placeholder="نام دوره را وارد کنید"
          onChange={(e) => setCourseName(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500  focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        />
        {error ? (
          <p className="text-red-500 w-full py-4">{error}</p>
        ) : (
          <div className="w-full my-4">
            <button
              onClick={handleUploadBarcode}
              type="button"
              className="text-white bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
            >
              آپلود
            </button>
          </div>
        )}
        {notFoundData?.length ? (
          <>
            <p className="my-4">لیست افرادی که ثبت نشدند</p>
            <Table
              columns={notFoundCoursesUserListColumns}
              rows={notFoundData}
            />
          </>
        ) : null}
      </div>
    </div>
  );
}

export default RegisterMultiple;
